import { useTranslation } from 'react-i18next';
import { FormatUtils } from '@shared/utils';
import { AccountType, type CardResponse, UserType, type AccountResponse } from '@shared/api';
import { Multiselect, Select } from '@shared/widgets';

interface ISelectUserAccountsAndCardsProps {
  selectedAccount?: number;
  accountList: AccountResponse[];
  accountLoading?: boolean;
  setSelectedAccount?: (val: number) => void;
  selectedAccounts?: number[];
  selectedCardValue?: number;
  selectedCards?: number[];
  cardList?: CardResponse[];
  cardLoading?: boolean;
  changeAccountOrCardId: (val: number[]) => void;
  userType: UserType;
}

export const SelectUserAccountsAndCards = (props: ISelectUserAccountsAndCardsProps) => {
  const { t } = useTranslation();

  return (
    <>
      {props.userType === UserType.USER && (
        <Select
          className='mb-4'
          isLoading={props.accountLoading}
          items={
            props.accountList.length > 0
              ? props.accountList.map((acc) => ({ value: acc.id, label: FormatUtils.toSliceNumber(acc.accountNumber), desc: acc.name }))
              : []
          }
          required
          nullValue={{ isEnable: false, text: t('placeholders.chooseAccount') }}
          value={props.selectedAccount}
          onChange={(val) => props.setSelectedAccount?.(val!)}
        />
      )}
      <Multiselect
        isLoading={props.cardLoading}
        items={
          props.userType === UserType.USER && props.cardList
            ? props.cardList.map((c) => ({ value: c.cardId, label: FormatUtils.toSliceNumber(c.cardNumber), desc: c.cardHolder }))
            : props.userType === UserType.MANAGER
              ? props.accountList.map((acc) => ({
                  value: acc.id,
                  label: acc.type === AccountType.Payment ? acc.accountNumber : FormatUtils.toSliceNumber(acc.accountNumber),
                  desc: acc.name,
                }))
              : []
        }
        required
        nullValue={{ isEnable: false, text: props.userType === UserType.USER ? t('placeholders.chooseCards') : t('placeholders.chooseAccounts') }}
        value={props.userType === UserType.USER ? props.selectedCards : props.userType === UserType.MANAGER ? props.selectedAccounts : []}
        onChange={(val) => props.changeAccountOrCardId(val!)}
      />
    </>
  );
};
